import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "./redux/clientProfileSaga";
import ClientInfoContent from "./smartComponents/ClientInfoContent";
import ClientsInfoDetails from "./smartComponents/ClientInfoDetails";
import ModulesConfigurator from "../../../components/modulesConfigurator/modulesConfigurator";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";

const ClientProfileModule = () => {
  const dispatch = useDispatch();
  const { error, haveError, isLoading, preferences } = useSelector(
    (state) => state.clientProfileModule
  );

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser());
  }, []);

  return (
    <div style={{ minHeight: "80vh" }}>
      {isLoading ? (
        <LoadingAnimation text="Gathering the most recent information" />
      ) : haveError ? (
        <div className="client-info-wrapper">
          <p className="error">
            Oops, we ran into the following error:
            <br />
            <span>{error}</span>
            <br />
            Please try again.
          </p>
        </div>
      ) : (
        <div className="client-info-wrapper">
          <ClientsInfoDetails />
          <div className="configurator-wrapper">
            <div id="clientProfileConfigurator">
              <ModulesConfigurator
                pageName="clientProfile"
                buttonLabel="Client Profile"
                pagePreferences={preferences}
                updatePreferences={(newListFiltered) => {
                  dispatch(actionCreators.updatePreferences(newListFiltered));
                }}
              />
            </div>
          </div>
          <ClientInfoContent />
        </div>
      )}
    </div>
  );
};

export default ClientProfileModule;
